import type { JSX } from 'react'

import { InlineCloseButton } from 'atoms/Button/Templates'
import { EPG_SIDEBAR_SKELETON_SIZES, INDENTS } from 'vars/index'
import {
  EpgSidebarBodySkeletonSC,
  EpgSidebarHeaderSkeletonSC,
  LogoSkeletonSC,
  SidebarSkeletonSC,
  TextBoxSkeletonSC,
} from './SidebarSkeleton.styled'

interface ISidebarSkeletonProps {
  isCloseBtnShown: boolean
  onClose: () => void
}

export const SidebarSkeleton = ({
  isCloseBtnShown,
  onClose,
}: ISidebarSkeletonProps): JSX.Element => {
  return (
    <SidebarSkeletonSC>
      <EpgSidebarHeaderSkeletonSC>
        <LogoSkeletonSC />
        <TextBoxSkeletonSC
          height={EPG_SIDEBAR_SKELETON_SIZES.CHANNEL_TITLE_SKELETON_HEIGHT}
          width={EPG_SIDEBAR_SKELETON_SIZES.CHANNEL_TITLE_SKELETON_WIDTH}
        />
        {isCloseBtnShown && (
          <InlineCloseButton onClick={onClose} paddings={[INDENTS.INDENT_40]} />
        )}
      </EpgSidebarHeaderSkeletonSC>
      <EpgSidebarBodySkeletonSC>
        <TextBoxSkeletonSC
          height={EPG_SIDEBAR_SKELETON_SIZES.LABEL_GROUP_SKELETON_HEIGHT}
          width={EPG_SIDEBAR_SKELETON_SIZES.LABEL_GROUP_SKELETON_WIDTH}
        />
        <TextBoxSkeletonSC
          height={EPG_SIDEBAR_SKELETON_SIZES.PROGRAM_TITLE_SKELETON_HEIGHT}
          width={EPG_SIDEBAR_SKELETON_SIZES.PROGRAM_TITLE_SKELETON_WIDTH}
        />
        <TextBoxSkeletonSC
          height={
            EPG_SIDEBAR_SKELETON_SIZES.PROGRAM_DESCRIPTION_SKELETON_HEIGHT
          }
          width={EPG_SIDEBAR_SKELETON_SIZES.PROGRAM_DESCRIPTION_SKELETON_WIDTH}
        />
      </EpgSidebarBodySkeletonSC>
    </SidebarSkeletonSC>
  )
}
